//Source: https://gitlab.com/bmgaynor/use-scroll-position/blob/master/lib/use-scroll-position.js
import { useEffect, useState } from 'react'
const useScrollPositionAfterThreshold = threshold => {
  const [afterThreshold, setIsAfterThreshold] = useState(false)

  useEffect(() => {
    let ticking = false
    const handleScroll = () => {
      const lastKnownScrollPos = window.scrollY
      if (!ticking) {
        window.requestAnimationFrame(() => {
          if (afterThreshold && lastKnownScrollPos < threshold) {
            setIsAfterThreshold(false)
          } else if (!afterThreshold && lastKnownScrollPos >= threshold) {
            setIsAfterThreshold(true)
          }
          ticking = false
        })
        ticking = true
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  })

  return afterThreshold
}
export default useScrollPositionAfterThreshold
